import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getClassRisks, getEnterpriseRisks, readableApiError } from '../../api/dashboard';
import { DimensionRisk } from './riskView';
import './dashboard.css';

// scope-aware（class | enterprise）。按 summary.scope_kind 三态渲染，去档位/去颜色分级。
export default function ClassRisksPage({ scope = 'class' }) {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const isEnt = scope === 'enterprise';
  const basePath = isEnt ? `/dashboard/enterprises/${id}` : `/dashboard/classes/${id}`;

  useEffect(() => {
    setData(null); setError(null);
    (isEnt ? getEnterpriseRisks(id) : getClassRisks(id))
      .then(setData).catch((err) => setError(readableApiError(err)));
  }, [id, isEnt]);

  if (error) return <div className="aiq-dash dash-page"><div className="dash-card dash-card--error">{error}</div></div>;
  if (!data) return <div className="aiq-dash dash-page"><div className="dash-card">加载中...</div></div>;

  const { summary = {}, dimensions = [] } = data;
  const scopeKind = summary.scope_kind || (isEnt ? 'enterprise_noclass' : 'class');

  return (
    <div className="aiq-dash dash-page">
      <div className="dash-head"><h1 className="dash-h1">风险预警</h1></div>
      <Link to={basePath} className="dash-back">← 返回总览</Link>

      {/* 全局摘要：受影响人数 + 最普遍短板（无颜色分级） */}
      <div className="dash-card">
        <div className="dash-sec"><h2>团队整体风险态势</h2></div>
        {dimensions.length === 0 ? (
          <div className="dash-mut">暂无风险（团队各维度均高于阈值）。</div>
        ) : (
          <>
            <div className="dash-mut">
              共 <b>{summary.affected_members ?? 0}</b> / {summary.total_members ?? 0} 人存在至少一项维度短板。
            </div>
            {summary.top_risk_dims?.length > 0 && (
              <div style={{ marginTop: 12 }}>
                <div className="dash-mut" style={{ marginBottom: 6 }}>最普遍的短板维度：</div>
                {summary.top_risk_dims.slice(0, 5).map((d) => (
                  <div key={d.dim_code} style={{ fontSize: 13, marginBottom: 4 }}>
                    · 「{d.dim_name}」<b>{d.affected}/{d.total}</b> 人存在短板
                  </div>
                ))}
              </div>
            )}
            {summary.cohort_text_pending && (
              <div className="dash-mut" style={{ marginTop: 10, color: '#b45309' }}>
                群像分析正在生成，部分文案为占位，请稍后刷新查看。
              </div>
            )}
          </>
        )}
      </div>

      {/* 按维度渲染（三态） */}
      {dimensions.map((dim) => (
        <DimensionRisk key={dim.dim_code} dim={dim} scopeKind={scopeKind} />
      ))}

      {summary.cache_hit && (
        <div className="dash-mut" style={{ fontSize: 11 }}>
          数据来自缓存（{summary.generated_at}）；成员状态变化时自动刷新。
        </div>
      )}
    </div>
  );
}
